export const nav = {
  dashboard: "لوحة التحكم",
  customers: "العملاء",
  quotes: "عروض الأسعار والطلبات",
  catalog: "الفهرس",
  jobs: "أوامر العمل",
  shopFloor: "أرضية الورشة",
  materials: "المواد والمشتريات",
  purchasing: "المشتريات",
  invoices: "الفواتير والنقدية",
  reports: "التقارير",
  documents: "المستندات",
  users: "المستخدمون",
  imports: "استيراد البيانات",
  auditTrail: "سجل التدقيق",
  settings: "الإعدادات",
};
